import { canAmend, canRecord, type AccessPolicy } from "./access";

/**
 * The three pricing bands, as the server resolves them
 * (`protection._ensure_unchanged_price`): `flexible_price` prices at will,
 * `price` prices down to the item's min-sell floor, and neither charges the
 * list price exactly. Both are subs of the sale posting, under the verb being
 * performed, so recording and amending are asked separately.
 */
export const canEditSalePrice = (
	access: AccessPolicy | null | undefined,
	action: "create" | "update" = "update",
): boolean => {
	const may = (modifier: string) =>
		action === "create" ? canRecord(access, "sale", modifier) : canAmend(access, "sale", modifier);
	return may("flexible_price") || may("price");
};

export const canSellBelowMinPrice = (
	access: AccessPolicy | null | undefined,
	action: "create" | "update" = "update",
): boolean =>
	action === "create"
		? canRecord(access, "sale", "flexible_price")
		: canAmend(access, "sale", "flexible_price");

const minSellFrom = (source: unknown): unknown => {
	if (!source || typeof source !== "object") return undefined;
	const o = source as Record<string, unknown>;
	return o.MinSellPrice ?? o.min_sell_price ?? o.minSellPrice;
};

export const catalogMinSellPrice = (catalog?: unknown, row?: unknown): number => {
	const n = Number(minSellFrom(row) ?? minSellFrom(catalog) ?? 0);
	return Number.isFinite(n) && n > 0 ? n : 0;
};
